import { lazy, type ComponentType, type LazyExoticComponent } from "react";
import type { RouteId } from "./routes";

type PageComponent = LazyExoticComponent<ComponentType>;

/**
 * Mapa feature (RouteId) → página lazy.
 * Solo las rutas presentes aquí y con `enabled !== false` en ROUTES
 * se registran en el router.
 *
 * Para activar una ruta deshabilitada: poner `enabled: true` (o quitar enabled)
 * en routes.ts y asegurar que exista entrada aquí.
 */
export const ROUTE_PAGES: Partial<Record<RouteId, PageComponent>> = {
  filing: lazy(() => import("@/features/filing/pages/FilingPage.tsx")),
  flatFiles: lazy(() => import("@/features/flat-file/pages/FlatFilePage.tsx")),
  manualConsolidatedFlatFiles: lazy(
    () =>
      import("@/features/manual-consolidated-flat-file/pages/ManualConsolidatedFlatFilePage.tsx"),
  ),
  support: lazy(
    () => import("@/features/delivery-support/pages/DeliverySupportPage.tsx"),
  ),
  deliverySupportReplacement: lazy(
    () =>
      import("@/features/delivery-support-replacement/pages/DeliverySupportReplacementPage.tsx"),
  ),
  syncDeliverySupport: lazy(
    () =>
      import("@/features/sync-delivery-support/pages/SyncDeliverySupportPage.tsx"),
  ),
  notifyNovelty: lazy(
    () => import("@/features/notify-novelty/pages/NotifyNoveltyPage.tsx"),
  ),
  suraNovelties: lazy(
    () => import("@/features/sura-novelties/pages/SuraNoveltiesPage.tsx"),
  ),
  // manualFlatFile: lazy(
  //   () => import("@/features/manual-flat-file/pages/FlatFilePage.tsx"),
  // ),
  // "billing-consolidated": lazy(
  //   () =>
  //     import("@/features/billing-consolidated/pages/BillingConsolidatedPage.tsx"),
  // ),
  // "pending-billing": lazy(
  //   () => import("@/features/pending-billing/pages/PendingBillingPage.tsx"),
  // ),
  // "filed-report": lazy(
  //   () => import("@/features/filed-report/pages/FiledReportPage.tsx"),
  // ),
  // historicalInvoices: lazy(
  //   () =>
  //     import("@/features/historical-invoices/pages/HistoricalInvoicesPage.tsx"),
  // ),
  filingRadicationDashboard: lazy(
    () =>
      import("@/features/filing-radication-dashboard/pages/FilingRadicationDashboardPage.tsx"),
  ),
  canceledReport: lazy(
    () =>
      import("@/features/canceled-report/pages/CanceledReportPage.tsx"),
  ),
  otherPlansReport: lazy(
    () =>
      import("@/features/other-plans-report/pages/OtherPlansReportPage.tsx"),
  ),
  missingDeliverySupportsReport: lazy(
    () =>
      import("@/features/missing-delivery-supports-report/pages/MissingDeliverySupportsReportPage.tsx"),
  ),
  bulkFlatFile: lazy(
    () => import("@/features/bulk-flat-file/pages/BulkFlatFilePage.tsx"),
  ),
  syncJobs: lazy(
    () => import("@/features/sync-jobs/pages/SyncJobsPage.tsx"),
  ),
  syncJobDetail: lazy(
    () => import("@/features/sync-jobs/pages/SyncJobDetailPage.tsx"),
  ),
  cityCodes: lazy(
    () => import("@/features/file-codes/pages/CityCodesPage.tsx"),
  ),
  users: lazy(() => import("@/features/users/pages/UsersPage.tsx")),
  pharmacyDirectories: lazy(
    () =>
      import("@/features/pharmacy-directories/pages/PharmacyDirectoriesPage.tsx"),
  ),
  affectationTypes: lazy(
    () =>
      import("@/features/affectation-types/pages/AffectationTypesPage.tsx"),
  ),
  ironPortfolios: lazy(
    () => import("@/features/iron-portfolios/pages/IronPortfoliosPage.tsx"),
  ),
  portfolioMasters: lazy(
    () =>
      import("@/features/portfolio-masters/pages/PortfolioMastersPage.tsx"),
  ),
  suraInconsistencyHomologations: lazy(
    () =>
      import(
        "@/features/sura-inconsistency-homologations/pages/SuraInconsistencyHomologationsPage.tsx"
      ),
  ),
};
